<style lang="scss">
    .songs{
        margin-top: 30px;
        .widget-title{
            color: #ff5b94;
            font-family: Poppins;
            font-size: 30px;
            font-weight: 600;
            text-transform: uppercase;
        }
    }

    @media screen and (max-width: 900px) {
        .songs [class*="col-"] {
            padding-left: 4px;
            padding-right: 4px;
        }
    }

    @media screen and (max-width: 768px) {
        .songs [class*="col-"] {
            padding: 4px;
        }
    }

</style>
<template>
    <div class="songs" v-if="songs.length > 0">
        <h3 class="widget-title" :style="$highlightColor">Songs</h3>
        <template v-if="songs">
            <div class="row">
                <song-container v-for="song in songs" :key="song.id" :song="song" class="col-xs-6 col-sm-3 col-md-3"></song-container>
            </div>
        </template>
        <div v-else class="text-center">
            <loading-icon></loading-icon>
        </div>

    </div>

</template>

<script>
    import SongContainer from './../songcontainer.vue'
    import LoadingIcon from './../loadingicon.vue'
    import Song from '../../models/song';
    import Configure from './../../mixins/configure'

	export default {
        props: ['pageId'],
        components: {
	        SongContainer,LoadingIcon
        },
        data() {
            return {
                music: [],
            }
        },
        computed: {
            page() {
                if (this.pageId) {
                    return this.config.getPageById(this.pageId)
                }
                return false
            },
            config() {
	            return this.$store.state.currentConfig
            },
            user() {
                return this.$store.state.user
            },
            playlistManager() {
                return this.$store.state.playlistManager
            },
            pagePlaylist() {
                return this.playlistManager.getPagePlaylist()
            },
            songs () {
                return this.$store.state.discoverPlaylist.songs
            }
        },
        mixins: [Configure],

	}
</script>